import { CreateSlotsAndSlotProps, List, ListProps, styled } from '@mui/material';
import { ContentIsland, ContentIslandProps } from './ContentIsland';

export type ListContentIslandSlotProps = CreateSlotsAndSlotProps<
  {
    list: typeof List;
  },
  {
    list: ListProps;
  }
>;

export type ListContentIslandProps = ContentIslandProps & ListContentIslandSlotProps;

const StyledList = styled(List, {
  name: 'ListContentIsland',
  slot: 'list',
})(({ theme }) => ({
  margin: theme.spacing(2, 0),
  padding: 0,
  width: '100%',
  backgroundColor: theme.palette.background.paper,
}));

export function ListContentIsland({
  children,
  slots,
  slotProps,
  ...props
}: ListContentIslandProps) {
  const ListComponent = slots?.list ?? StyledList;

  return (
    <ContentIsland {...props}>
      <ListComponent {...slotProps?.list}>{children}</ListComponent>
    </ContentIsland>
  );
}
